import { ReactNode } from "react";
import { CoreButton } from "@verity/components/core";
import styles from "./DownloadButton.module.css";

export default function DownloadButton({
	downloadUrl,
	onClick,
	openUrl,
	loading,
	children,
}: {
	downloadUrl?: string;
	onClick?: () => void;
	openUrl?: boolean;
	loading?: boolean;
	children: ReactNode;
}) {
	return (
		<CoreButton
			size="large"
			component="a"
			className={styles.downloadButton}
			href={downloadUrl}
			loading={loading}
			loadingPosition="end"
			onClick={() => onClick?.()}
			{...(openUrl && { target: "_blank", rel: "noopener noreferrer" })}
		>
			{children}
		</CoreButton>
	);
}
